// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2oW47","footerRight":"footer_footerRight__Zvk28","mobileButton":"footer_mobileButton__-OoiK"};